
  export default {
    name: `GetStartedPage`
  }
